import { z } from 'zod';

const MensajeLicitacionUiSchema = z.object({
  id: z.string(),
  fecha_creacion: z.string(),
  mensaje: z.string(),
  usuario_autor: z.string(),
  activo: z.boolean()
});

export const ListarMensajesLicitacionesUiSchema = z.array(MensajeLicitacionUiSchema);

export type ListarMensajesLicitacionesUi = z.infer<typeof ListarMensajesLicitacionesUiSchema>;
export type MensajeLicitacionUi = z.infer<typeof MensajeLicitacionUiSchema>; 